/*
 * Created by efowler on 1/23/14.
 */
'use strict';

frontendApp.controller('AddTagReportModalCtrl', ['$scope', '$uibModalInstance', 'project', 'collections', 'search', 'filter', 'config', 'formConfig', 'ReportService', 'HttpService', 'ConfigService', 'NotificationService', 'PreferenceService', function($scope, $uibModalInstance, project, collections, search, filter, config, formConfig, ReportService, HttpService, ConfigService, NotificationService, PreferenceService) {

    $scope.project = project;

    $scope.saving = false;

    $scope.step = 1;
    $scope.maxSteps = 1;

    $scope.close = function() {
        if ($scope.saving) return;
        $uibModalInstance.close();
    };

    $scope.newReport = {
        projectId: project.id,
        type: "",
        format: "zip",
        name: "",
        multiValueCharCode: 59,
        dateTimeFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSZ",
        hasHeaderRow: true,
        fields: [],
        includeProjectTags: PreferenceService.Get(app.model.user.Preferences.TAG_REPORT_PROJECT),
        includeSystemTags: PreferenceService.Get(app.model.user.Preferences.TAG_REPORT_SYSTEM),
        includeDomainTags: PreferenceService.Get(app.model.user.Preferences.TAG_REPORT_DOMAIN),
        includeBatchTags: PreferenceService.Get(app.model.user.Preferences.TAG_REPORT_BATCH)
    };

    $scope.$on(app.services.user.PreferenceService.GetEventForPreference(app.model.user.Preferences.TAG_REPORT_PROJECT), function(evt, val) {
        $scope.newReport.includeProjectTags = val;
    });
    $scope.$on(app.services.user.PreferenceService.GetEventForPreference(app.model.user.Preferences.TAG_REPORT_SYSTEM), function(evt, val) {
        $scope.newReport.includeSystemTags = val;
    });
    $scope.$on(app.services.user.PreferenceService.GetEventForPreference(app.model.user.Preferences.TAG_REPORT_DOMAIN), function(evt, val) {
        $scope.newReport.includeDomainTags = val;
    });
    $scope.$on(app.services.user.PreferenceService.GetEventForPreference(app.model.user.Preferences.TAG_REPORT_BATCH), function(evt, val) {
        $scope.newReport.includeBatchTags = val;
    });

    // Report specific data (must include format)
    angular.extend($scope.newReport, config);

    $scope.saveReport = function(report) {

        // TODO: do this validation on the form itself
        if (!report.includeProjectTags &&
        !report.includeSystemTags &&
        !report.includeDomainTags &&
        !report.includeBatchTags) {

            NotificationService.addError({
                title: 'Error',
                description: 'You must choose at least one tag category'
            });

            return;
        }

        $scope.saving = true;

        // save pref
        PreferenceService.Set(app.model.user.Preferences.TAG_REPORT_PROJECT, report.includeProjectTags);
        PreferenceService.Set(app.model.user.Preferences.TAG_REPORT_SYSTEM, report.includeSystemTags);
        PreferenceService.Set(app.model.user.Preferences.TAG_REPORT_DOMAIN, report.includeDomainTags);
        PreferenceService.Set(app.model.user.Preferences.TAG_REPORT_BATCH, report.includeBatchTags);

        var newReport = ReportService.Create({
            projectId: project.id,
            type: report.type,
            format: report.format,
            name: report.name,
            multiValueCharCode: report.multiValueCharCode,
            dateTimeFormat: report.dateTimeFormat,
            hasHeaderRow: report.hasHeaderRow,
            fields: report.fields,
            includeProjectTags: report.includeProjectTags,
            includeSystemTags: report.includeSystemTags,
            includeDomainTags: report.includeDomainTags,
            includeBatchTags: report.includeBatchTags,
            columnFilters: $scope.columnFilters });

        angular.extend(newReport, { collectionIds: collections ? collections : [], filter: filter, columnFilters: app.directives.controls.DataGrid.GetSearchExpressionFromFilterModel(PreferenceService.Get(app.model.user.Preferences.GRID_COLUMNS_FILTER_MODEL)) });

        if(search) {
            angular.extend(newReport, {
                query: search instanceof app.model.search.BasicSearch ? search.expression : "",
                searchExpression: search instanceof app.model.search.AdvancedSearch ? search.expression : null
            });
        }


        ReportService.Save(newReport).then(function(report) {

            $scope.saving = false;
            $scope.close();

            NotificationService.addSuccess({
                title: 'Report started',
                description: 'Name: ' + report.name,
                timeout: 5000
            });

        }).catch(function(data) {
            $scope.saving = false;
        });

    };


}]);

